import { render, staticRenderFns } from "./searchSuspectedFailure.vue?vue&type=template&id=649bfa69&scoped=true&"
import script from "./searchSuspectedFailure.vue?vue&type=script&lang=js&"
export * from "./searchSuspectedFailure.vue?vue&type=script&lang=js&"
import style0 from "./searchSuspectedFailure.vue?vue&type=style&index=0&id=649bfa69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649bfa69",
  null
  
)

export default component.exports